import React from 'react';
import { RefreshCw } from 'lucide-react';

const WalletBalanceCard = ({
  balance,
  onRefresh,
  refreshing,
  t,
  isMobile = false
}) => {
  if (isMobile) {
    return (
      <div style={{
        background: 'linear-gradient(135deg, #1e2329 0%, #2b3139 100%)',
        borderRadius: '16px',
        padding: '20px',
        marginBottom: '16px',
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'flex-start',
        }}>
          <div>
            <div style={{ color: '#848e9c', fontSize: '12px', marginBottom: '4px' }}>
              {t('exchangeBalance') || 'Баланс биржи'}
            </div>
            <div style={{ 
              fontSize: '28px', 
              fontWeight: '700', 
              color: '#eaecef', 
              fontFamily: 'monospace' 
            }}>
              ${balance?.exchange_balance?.toLocaleString(undefined, { minimumFractionDigits: 2 }) || '0.00'}
            </div>
          </div>
          <button
            onClick={onRefresh}
            style={{
              padding: '8px',
              backgroundColor: '#2b3139',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
          >
            <RefreshCw 
              size={18} 
              color="#848e9c" 
              style={{ animation: refreshing ? 'spin 1s linear infinite' : 'none' }} 
            />
          </button>
        </div>
      </div>
    );
  }

  // Desktop version - simple balance card
  return (
    <div style={{
      backgroundColor: '#1e2329',
      border: '1px solid #2b3139',
      borderRadius: '12px',
      padding: '24px',
      maxWidth: '400px',
      marginBottom: '32px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <div style={{ color: '#848e9c', fontSize: '14px' }}>{t('exchangeBalance') || t('totalBalance') || 'Баланс биржи'}</div>
        <button
          onClick={onRefresh}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
        >
          <RefreshCw size={16} color="#848e9c" style={{ animation: refreshing ? 'spin 1s linear infinite' : 'none' }} />
        </button>
      </div>
      <div style={{ fontSize: '32px', fontWeight: '700', color: '#eaecef' }}>
        ${balance?.exchange_balance?.toFixed(2) || '0.00'}
      </div>
    </div>
  );
};

export default WalletBalanceCard;
